import * as React from 'react';

// tslint:disable:max-line-length
export const SecureCamIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M16 16h-5a1 1 0 0 1-1-1v-4h2v3h4v2zM12 0H1a1.003 1.003 0 0 0-.962 1.275l2 6.999A1 1 0 0 0 3 9h12a1 1 0 0 0 1-1V4a4 4 0 0 0-4-4z" />
    </g>
  </svg>
);
